// -- == //
import { ThunkDispatch } from 'redux-thunk';
import { toast } from 'common/helpers/toastConfig';
import { RootState } from 'redux/reducers';
import { AnyAction } from 'redux';

import * as types from 'common/constants';
// import * as T from "common/types";
import * as services from 'common/services';

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria Menu Management list actions
 */
export const cafeteriaMenuManagementRequestAction = (data: object) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.CAFETERIA_MENU.REQUEST,
        payload: {}
      });

      const response: any = await services.cafeteriaMenuManagementService(data);

      if (response.status === 200 || response.status === 201) {
        dispatch(cafeteriaMenuManagementSuccessAction(response.data?.data));
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(cafeteriaMenuManagementFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(cafeteriaMenuManagementFailureAction(error));
      throw error;
    }
  };
};

export const cafeteriaMenuManagementSuccessAction = (data: object) => {
  return {
    type: types.CAFETERIA_MENU.SUCCESS,
    payload: data
  };
};

export const cafeteriaMenuManagementFailureAction = (error: object) => {
  return {
    type: types.CAFETERIA_MENU.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria Create Menu Management actions
 */
export const cafeteriaCreateMenuManagementRequestAction = (data: any, callBack: () => void, setLoading: () => void) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.CAFETERIA_CREATE_MENU.REQUEST,
        payload: {}
      });

      const formData = new FormData();

      formData.append('image', data.image);
      formData.append('translations', JSON.stringify(data.translations));
      formData.append('status', data.status.toString());
      formData.append('category', data.category);
      if (Array.isArray(data.menuOptions) && data.menuOptions.length > 0) {
        formData.append('menuOptions', JSON.stringify(data.menuOptions));
        // data.menuOptions.forEach((option: any, index: number) => {
        //   formData.append(`menuOptions[${index}][id]`, option.id);
        //   formData.append(`menuOptions[${index}][isActive]`, option.isActive);
        // });
      }

      const response: any = await services.cafeteriaCreateMenuManagementService(formData);

      if (response.status === 200 || response.status === 201) {
        toast({ model: 'success', message: 'Menu item created successfully' });
        dispatch(cafeteriaCreateMenuManagementSuccessAction(response.data));
        callBack && callBack();
        setLoading && setLoading();
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(cafeteriaCreateMenuManagementFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(cafeteriaCreateMenuManagementFailureAction(error));
      throw error;
    }
  };
};

export const cafeteriaCreateMenuManagementSuccessAction = (data: object) => {
  return {
    type: types.CAFETERIA_CREATE_MENU.SUCCESS,
    payload: data
  };
};

export const cafeteriaCreateMenuManagementFailureAction = (error: object) => {
  return {
    type: types.CAFETERIA_CREATE_MENU.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria Edit Menu Management actions
 */
export const cafeteriaEditMenuManagementRequestAction = (data: any, callBack: () => void) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.CAFETERIA_EDIT_MENU.REQUEST,
        payload: {}
      });

      const response: any = await services.cafeteriaEditMenuManagementService(data);

      if (response.status === 200 || response.status === 201) {
        dispatch(cafeteriaEditMenuManagementSuccessAction(response.data));
        callBack && callBack();
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(cafeteriaEditMenuManagementFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(cafeteriaEditMenuManagementFailureAction(error));
      throw error;
    }
  };
};

export const cafeteriaEditMenuManagementSuccessAction = (data: object) => {
  return {
    type: types.CAFETERIA_EDIT_MENU.SUCCESS,
    payload: data
  };
};

export const cafeteriaEditMenuManagementFailureAction = (error: object) => {
  return {
    type: types.CAFETERIA_EDIT_MENU.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria Upload actions
 */
export const cafeteriaUploadRequestAction = (data: any, callBack: (fileName: string) => void) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.CAFETERIA_UPLOAD.REQUEST,
        payload: {}
      });

      const formData = new FormData();
      formData.append('image', data.image);

      const response: any = await services.cafeteriaUploadService(formData);

      if (response.status === 200 || response.status === 201) {
        dispatch(cafeteriaUploadSuccessAction(response.data));
        callBack && callBack(response.data?.data?.fileNameOnly);
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(cafeteriaUploadFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(cafeteriaUploadFailureAction(error));
      throw error;
    }
  };
};

export const cafeteriaUploadSuccessAction = (data: object) => {
  return {
    type: types.CAFETERIA_UPLOAD.SUCCESS,
    payload: data
  };
};

export const cafeteriaUploadFailureAction = (error: object) => {
  return {
    type: types.CAFETERIA_UPLOAD.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria Chart actions
 */
export const cafeteriaChartRequestAction = (data: object) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.CAFETERIA_CHART.REQUEST,
        payload: {}
      });

      const response: any = await services.cafeteriaChartService(data as { items: string; date: string });

      if (response.status === 200 || response.status === 201) {
        dispatch(cafeteriaChartSuccessAction(response.data));
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(cafeteriaChartFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(cafeteriaChartFailureAction(error));
      throw error;
    }
  };
};

export const cafeteriaChartSuccessAction = (data: object) => {
  return {
    type: types.CAFETERIA_CHART.SUCCESS,
    payload: data
  };
};

export const cafeteriaChartFailureAction = (error: object) => {
  return {
    type: types.CAFETERIA_CHART.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria Edit Menu Management actions
 */
export const cafeteriaStatusRequestAction = (data: object, callBack: () => void) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.CAFETERIA_STATUS.REQUEST,
        payload: {}
      });

      const response: any = await services.cafeteriaStatusService(data);

      if (response.status === 200 || response.status === 201) {
        dispatch(cafeteriaStatusSuccessAction(response.data));
        callBack && callBack();
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(cafeteriaStatusFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(cafeteriaStatusFailureAction(error));
      throw error;
    }
  };
};

export const cafeteriaStatusSuccessAction = (data: object) => {
  return {
    type: types.CAFETERIA_STATUS.SUCCESS,
    payload: data
  };
};

export const cafeteriaStatusFailureAction = (error: object) => {
  return {
    type: types.CAFETERIA_STATUS.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria Create Menu Customization actions
 */
export const menuCustomizationCreateRequestAction = (data: any, callBack: () => void) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.MENU_CUSTOMIZATION_CREATE.REQUEST,
        payload: {}
      });

      const response: any = await services.MenuCustomizationCreateService(data);

      if (response.status === 200 || response.status === 201) {
        dispatch(menuCustomizationCreateSuccessAction(response.data.data));
        callBack && callBack();
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(menuCustomizationCreateFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(menuCustomizationCreateFailureAction(error));
      throw error;
    }
  };
};

export const menuCustomizationCreateSuccessAction = (data: object) => {
  return {
    type: types.MENU_CUSTOMIZATION_CREATE.SUCCESS,
    payload: data
  };
};

export const menuCustomizationCreateFailureAction = (error: object) => {
  return {
    type: types.MENU_CUSTOMIZATION_CREATE.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria Menu Management list actions
 */
export const menuCustomizationListRequestAction = (data: object) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.MENU_CUSTOMIZATION.REQUEST,
        payload: {}
      });

      const response: any = await services.MenuCustomizationService(data);

      if (response.status === 200 || response.status === 201) {
        dispatch(menuCustomizationListSuccessAction(response.data?.data));
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(menuCustomizationListFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(menuCustomizationListFailureAction(error));
      throw error;
    }
  };
};

export const menuCustomizationListSuccessAction = (data: object) => {
  return {
    type: types.MENU_CUSTOMIZATION.SUCCESS,
    payload: data
  };
};

export const menuCustomizationListFailureAction = (error: object) => {
  return {
    type: types.MENU_CUSTOMIZATION.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * menu customization Detail actions
 */
export const MenuCustomDetailRequestAction = (id: string | number) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.MENU_CUSTOMIZATION_DETAIL.REQUEST,
        payload: {}
      });

      const response: any = await services.MenuCustomizationItemService(id);

      if (response.status === 200 || response.status === 201) {
        dispatch(menuDetailSuccessAction(response.data?.data));
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(menuDetailFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(menuDetailFailureAction(error));
      throw error;
    }
  };
};

export const menuDetailSuccessAction = (data: object) => {
  return {
    type: types.MENU_CUSTOMIZATION_DETAIL.SUCCESS,
    payload: data
  };
};

export const menuDetailFailureAction = (error: object) => {
  return {
    type: types.MENU_CUSTOMIZATION_DETAIL.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria Create Menu Customization actions
 */
export const menuCustomizationUpdateRequestAction = (data: any, id: string | number, callBack: () => void) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.MENU_CUSTOMIZATION_CREATE.REQUEST,
        payload: {}
      });

      const response: any = await services.MenuCustomizationUpdateService(data, id);

      if (response.status === 200 || response.status === 201) {
        toast({ model: 'success', message: 'Custom menu updated successfully' });
        dispatch(menuCustomizationUpdateSuccessAction(response.data));
        callBack && callBack();
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(menuCustomizationUpdateFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(menuCustomizationUpdateFailureAction(error));
      throw error;
    }
  };
};

export const menuCustomizationUpdateSuccessAction = (data: object) => {
  return {
    type: types.MENU_CUSTOMIZATION_CREATE.SUCCESS,
    payload: data
  };
};

export const menuCustomizationUpdateFailureAction = (error: object) => {
  return {
    type: types.MENU_CUSTOMIZATION_CREATE.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * menu customization Detail actions
 */
export const MenuManagementDetailRequestAction = (id: string | number) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.MENU_MANAGEMENT_DETAIL.REQUEST,
        payload: {}
      });

      const response: any = await services.MenuManagementDetailService(id);

      if (response.status === 200 || response.status === 201) {
        dispatch(menuManagementDetailSuccessAction(response.data.data));
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(menuManagementDetailFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(menuManagementDetailFailureAction(error));
      throw error;
    }
  };
};

export const menuManagementDetailSuccessAction = (data: object) => {
  return {
    type: types.MENU_MANAGEMENT_DETAIL.SUCCESS,
    payload: data
  };
};

export const menuManagementDetailFailureAction = (error: object) => {
  return {
    type: types.MENU_MANAGEMENT_DETAIL.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria update Menu management actions
 */
export const menuManagementUpdateRequestAction = (data: any, callBack: () => void, setLoading: () => void) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.MENU_MANAGEMENT_UPDATE.REQUEST,
        payload: {}
      });

      const response: any = await services.MenuManagementUpdateService(data);

      if (response.status === 200 || response.status === 201) {
        toast({ model: 'success', message: 'Menu item updated successfully' });
        dispatch(menuManagementUpdateSuccessAction(response.data.data));
        callBack && callBack();
        setLoading && setLoading();
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(menuManagementUpdateFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(menuManagementUpdateFailureAction(error));
      throw error;
    }
  };
};

export const menuManagementUpdateSuccessAction = (data: object) => {
  return {
    type: types.MENU_MANAGEMENT_UPDATE.SUCCESS,
    payload: data
  };
};

export const menuManagementUpdateFailureAction = (error: object) => {
  return {
    type: types.MENU_MANAGEMENT_UPDATE.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria reject reasons list actions
 */
export const rejectReasonsListRequestAction = (data: object) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.REJECT_REASONS_LIST.REQUEST,
        payload: {}
      });

      const response: any = await services.RejectReasonsListService(data);

      if (response.status === 200 || response.status === 201) {
        dispatch(rejectReasonsListSuccessAction(response.data?.data));
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(rejectReasonsListFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(rejectReasonsListFailureAction(error));
      throw error;
    }
  };
};

export const rejectReasonsListSuccessAction = (data: object) => {
  return {
    type: types.REJECT_REASONS_LIST.SUCCESS,
    payload: data
  };
};

export const rejectReasonsListFailureAction = (error: object) => {
  return {
    type: types.REJECT_REASONS_LIST.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria Create Menu Customization actions
 */
export const rejectReasonCreateRequestAction = (data: any, callBack: () => void) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.REJECT_REASON_CREATE.REQUEST,
        payload: {}
      });

      const response: any = await services.RejectReasonCreateService(data);

      if (response.status === 200 || response.status === 201) {
        toast({ model: 'success', message: 'Reject Reason created successfully' });
        dispatch(rejectReasonCreateSuccessAction(response.data));
        callBack && callBack();
      } else {
        toast({ model: 'error', message: response.data.devMessage || 'No client message available' });
        dispatch(rejectReasonCreateFailureAction(response));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(rejectReasonCreateFailureAction(error));
      toast({ model: 'error', message: error.response.data.devMessage || 'No client message available' });
      // throw error;
    }
  };
};

export const rejectReasonCreateSuccessAction = (data: object) => {
  return {
    type: types.REJECT_REASON_CREATE.SUCCESS,
    payload: data
  };
};

export const rejectReasonCreateFailureAction = (error: object) => {
  return {
    type: types.REJECT_REASON_CREATE.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria reject reason actions
 */
export const rejectReasonGetOneRequestAction = (id: string | number) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.REJECT_REASON_GET_ONE.REQUEST,
        payload: {}
      });

      const response: any = await services.RejectReasonGetOneService(id);

      if (response.status === 200 || response.status === 201) {
        dispatch(rejectReasonGetOneSuccessAction(response.data?.data));
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(rejectReasonGetOneFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(rejectReasonGetOneFailureAction(error));
      throw error;
    }
  };
};

export const rejectReasonGetOneSuccessAction = (data: object) => {
  return {
    type: types.REJECT_REASON_GET_ONE.SUCCESS,
    payload: data
  };
};

export const rejectReasonGetOneFailureAction = (error: object) => {
  return {
    type: types.REJECT_REASON_GET_ONE.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria Create Menu Customization actions
 */
export const rejectReasonUpdateRequestAction = (data: any, callBack: () => void) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.REJECT_REASON_UPDATE.REQUEST,
        payload: {}
      });

      const response: any = await services.RejectReasonUpdateService(data);

      if (response.status === 200 || response.status === 201) {
        toast({ model: 'success', message: 'Reject reason updated successfully' });
        dispatch(rejectReasonUpdateSuccessAction(response.data));
        callBack && callBack();
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(rejectReasonUpdateFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(rejectReasonUpdateFailureAction(error));
      toast({ model: 'error', message: error.response.data.devMessage || 'No client message available' });
      // throw error;
    }
  };
};

export const rejectReasonUpdateSuccessAction = (data: object) => {
  return {
    type: types.REJECT_REASON_UPDATE.SUCCESS,
    payload: data
  };
};

export const rejectReasonUpdateFailureAction = (error: object) => {
  return {
    type: types.REJECT_REASON_UPDATE.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria orders list actions
 */
export const ordersListRequestAction = (data: object) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.ORDERS_LIST.REQUEST,
        payload: {}
      });

      const response: any = await services.OrdersListService(data);

      if (response.data) {
        dispatch(ordersListSuccessAction(response.data?.data));
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(ordersListFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(ordersListFailureAction(error));
      throw error;
    }
  };
};

export const ordersListSuccessAction = (data: object) => {
  return {
    type: types.ORDERS_LIST.SUCCESS,
    payload: data
  };
};

export const ordersListFailureAction = (error: object) => {
  return {
    type: types.ORDERS_LIST.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * cafeteria orders list actions
 */
export const ordersListDetailRequestAction = (id: number | string) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.ORDERS_DETAIL.REQUEST,
        payload: {}
      });

      const response: any = await services.OrdersListGetOneService(id);

      if (response.data) {
        dispatch(ordersListDetailSuccessAction(response.data?.data));
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(ordersListDetailFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(ordersListDetailFailureAction(error));
      throw error;
    }
  };
};

export const ordersListDetailSuccessAction = (data: object) => {
  return {
    type: types.ORDERS_DETAIL.SUCCESS,
    payload: data
  };
};

export const ordersListDetailFailureAction = (error: object) => {
  return {
    type: types.ORDERS_DETAIL.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/
